import { Status } from "./Status";

export class UserPermissionsLevelSmartEnum {
    static Level1 = new Status("Level 1 - Customer", 1, "pill--yellow");
    static Level2 = new Status("Level 2 - Customer", 2, "pill--green"); 

    public static getName() {
        // Cannot use this.name as it will be the minified value in production
        return "UserPermissionsLevelSmartEnum";
    }
}
